import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { automaticApi } from "../../../settings/api";
import { clearString } from "@/utils/functions";

export interface Fetch {
  document: string;
  pin: string;
  callback: (success: boolean, errorMessage?: string) => void;
}

export interface ValidatePinRegisterAction {
  type: string;
  payload: Fetch;
}

export default function* validatePinRegister({
  payload,
}: ValidatePinRegisterAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const data = {
      cpfCnpj: clearString(payload.document),
      pin: payload.pin,
      actionId: 1019,
    };
    const response = yield call(
      automaticApi.post,
      `/pedido/v1/validaPin`,
      data,
    );
    const responseData = response?.data;

    if (response?.data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true, responseData?.hash ?? "hash");
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(
      payload.callback,
      false,
      // @ts-expect-error
      error?.response?.data?.status?.codigoRetorno === -1002
        ? "document"
        : "timeout",
    );
  }
}
